var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _g5, _path10, _g6, _path11, _path12, _g7, _path13, _path14, _path15, _path16, _path17, _ellipse, _path18, _path19, _path20, _path21, _ellipse2, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetNewPasswordSucceed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 143,
    viewBox: "0 0 154 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.7204 69.7535H13.1567C15.1608 76.2184 16.4015 89.9196 32.5299 90.3603C48.6582 90.8011 52.4438 77.0265 55.7204 69.7535Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1567 69.7535H55.7204M13.1567 69.7535C15.1608 76.2184 16.4015 89.9196 32.5299 90.3603M13.1567 69.7535L5.0448 141.974M55.7204 69.7535C52.4438 77.0265 48.6582 90.8011 32.5299 90.3603M55.7204 69.7535L61.7327 141.974M32.5299 90.3603L29.7623 141.974",
    stroke: "black",
    strokeWidth: 0.92931
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_524_14341",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 101,
    width: 43,
    height: 31
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.678 131.154L111.783 107.59C115.08 103.452 122.616 97.0221 126.386 104.403C131.099 113.63 133.356 111.241 141.388 110.51C147.813 109.926 152.473 115.843 154 118.874L120.678 131.154Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_524_14341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.678 131.154L111.783 107.59C115.08 103.452 122.616 97.0221 126.386 104.403C131.099 113.63 133.356 111.241 141.388 110.51C147.813 109.926 152.473 115.843 154 118.874L120.678 131.154Z",
    fill: "#AE5848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.17 107.258L113.774 117.746L108.597 109.382L129.041 102.346L130.17 107.258Z",
    fill: "#843628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.705 117.879L113.774 119.936L120.412 133.544L164.82 127.238L162.297 108.984L130.568 107.125C128.555 107.767 125.709 110.165 125.391 112.767C125.072 115.369 128.245 117.148 129.705 117.879Z",
    fill: "#01B388"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.695 129.76L144.773 119.363M155.593 115.356L144.773 119.363M143.711 107.722C137.828 107.722 135.889 113.391 138.593 116.816M144.773 119.363C141.805 119.363 139.763 118.3 138.593 116.816M138.593 116.816C138.404 116.816 136.901 117.006 134.684 117.301M115.035 120.003C119.222 119.417 125.767 118.507 130.9 117.81M130.9 117.81C121.275 115.821 126.253 107.324 129.904 108.253M130.9 117.81C131.449 117.735 131.981 117.663 132.493 117.594M132.493 117.594L133.489 109.448M132.493 117.594C133.277 117.488 134.013 117.39 134.684 117.301M134.684 117.301L135.546 109.448",
    stroke: "#027357",
    strokeWidth: 0.92931
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_524_14341",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 113,
    width: 39,
    height: 29
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6948 132.15L55.825 113.365C60.3388 114.161 66.7378 115.887 65.2509 119.604C63.3922 124.251 60.9362 128.167 70.8931 132.15C78.8586 135.336 78.3276 140.027 77.0664 141.974H55.825L39.6948 132.15Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_524_14341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6328 132.15L55.8251 113.365C60.3388 114.161 66.7378 115.887 65.2509 119.604C63.3923 124.251 60.9363 128.167 70.8932 132.15C78.8587 135.336 78.3276 140.027 77.0664 141.974H55.8251L38.6328 132.15Z",
    fill: "#AE5848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1275 128.279L46.6719 117.885L52.0472 109.647L67.0961 125.172L63.1275 128.279Z",
    fill: "#843628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5595 128.698L45.7354 120.534L35.8448 133.942L68.7026 147.417L88.4836 142.771C83.3061 136.929 71.1985 124.835 64.1888 123.189C57.1792 121.543 55.5153 126.176 55.5595 128.698Z",
    fill: "#01B388"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6509 139.253L67.0431 139.518M40.3586 129.03L57.4181 139.518H67.0431M67.0431 139.518C65.4575 138.073 65.1006 135.708 65.4659 134.274M71.6897 130.823C69.2782 129.66 66.1404 131.626 65.4659 134.274M65.4659 134.274L61.442 132.548M46.4655 121.198L55.7586 129.364M55.7586 129.364L57.4181 130.823L58.4802 131.278M55.7586 129.364C54.6966 122.06 62.3966 121.198 67.0431 125.313M61.442 132.548L67.375 128.566M61.442 132.548L58.4802 131.278M58.4802 131.278L65.4659 127.039",
    stroke: "#027357",
    strokeWidth: 0.92931
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_524_14341",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 43,
    width: 124,
    height: 88
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9928 58.5416C74.8454 51.7146 88.4466 43.202 106.141 43.2019C111.314 43.2019 117.956 53.176 123.833 65.6165C134.733 68.4082 141.255 72.5907 141.72 79.7768C142.004 84.1776 139.241 88.996 134.611 93.8896C135.579 97.1576 136.37 100.203 136.941 102.877L107.866 115.622L107.308 114.022C95.5385 120.936 83.2723 126.86 75.0087 130.491L43.9432 113.564C60.3968 101.044 69.6602 94.0444 95.6526 86.2156C79.3011 86.7467 42.2439 86.0829 27.4811 78.1173C12.7184 70.1518 18.7433 55.7454 23.6012 50.1684H54.7995L57.219 57.6725C60.1911 57.9797 63.1176 58.2676 65.9928 58.5416Z",
    fill: "#DD1B1B"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_524_14341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7994 50.1683H23.6011C18.7432 55.7453 12.7182 70.1517 27.481 78.1173C42.2438 86.0828 79.301 86.7466 95.6525 86.2155C69.6601 94.0443 60.3967 101.044 43.9431 113.564L75.0086 130.491C96.0066 121.264 142.848 97.2345 141.72 79.7767C140.607 62.5657 104.747 62.5845 57.2189 57.6724L54.7994 50.1683Z",
    fill: "#006B51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.331 46.72C31.4637 47.3838 21.2413 62.7174 26.2861 67.2976C33.4551 77.7855 94.1258 78.6484 124.859 78.6484C106.384 87.9194 65.9412 109.037 51.975 119.339",
    stroke: "#004736",
    strokeWidth: 0.92931
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8473 52.8267L36.3094 52.6627M59.8076 52.4285L52.9706 52.4966M25.5559 60.1285C30.6264 59.6917 33.5759 58.0856 36.3094 52.6627M36.3094 52.6627L52.9706 52.4966M52.9706 52.4966C53.0812 54.0227 54.4309 57.8052 57.5507 58.0707",
    stroke: "#004736",
    strokeWidth: 0.92931
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.141 43.2019C88.3945 43.202 74.7652 51.7648 65.9147 58.6019L89.081 61.7881L107.866 115.622L136.941 102.877C132.737 83.1623 116.496 43.2019 106.141 43.2019Z",
    fill: "#006B51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.943 56.6768L88.5499 61.3897L107.734 116.75L137.604 103.275C133.4 83.5604 116.827 42.5379 106.472 42.538",
    stroke: "#004736",
    strokeWidth: 0.92931
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.027 116.352C117.159 115.622 98.8387 54.088 93.5284 53.8225C89.2801 53.6101 81.2704 57.8495 77.7965 59.9958",
    stroke: "#004736",
    strokeWidth: 0.92931
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5825 59.5649C65.9368 55.8206 60.3337 48.6345 57.5679 44.696L65.2015 39.1865L75.4903 51.3339L65.467 24.5166C58.298 20.6666 59.3601 17.0822 64.4713 19.9365C60.0239 10.7761 63.8739 9.5813 65.8653 15.6882C65.0024 8.45285 67.5248 9.18302 68.9851 14.6925C69.3672 9.02935 71.5088 9.07966 72.4368 15.6882C72.7671 18.04 72.9236 21.087 72.9015 22.3261C75.092 27.3267 82.1367 40.1957 86.642 53.9891C90.9567 67.1985 76.6921 66.8666 69.5825 59.5649Z",
    fill: "#AE5848"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_524_14341",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 10,
    width: 31,
    height: 55
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5825 59.5649C65.9368 55.8206 60.3337 48.6345 57.5679 44.696L65.2015 39.1865L75.4903 51.3339L65.467 24.5166C58.298 20.6666 59.3601 17.0822 64.4713 19.9365C60.0239 10.7761 63.8739 9.5813 65.8653 15.6882C65.0024 8.45285 67.5248 9.18302 68.9851 14.6925C69.3672 9.02935 71.5088 9.07966 72.4368 15.6882C72.7671 18.04 72.9236 21.087 72.9015 22.3261C75.092 27.3267 82.1367 40.1957 86.642 53.9891C90.9567 67.1985 76.6921 66.8666 69.5825 59.5649Z",
    fill: "#AE5848"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_524_14341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9575 53.2589L69.5161 42.6382V39.7175L57.5015 43.7003L59.9575 53.2589Z",
    fill: "#843628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.467 10.3779L66.5291 17.0822M68.7196 9.18311L69.7153 16.4848",
    stroke: "#843628",
    strokeWidth: 0.92931,
    strokeLinejoin: "bevel"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8696 38.8546L78.2119 54.6529M66.7946 19.5382C67.8302 19.7894 68.5317 20.5707 68.9851 21.5296C69.0415 20.2189 69.1237 19.3297 69.7817 18.6089",
    stroke: "#843628",
    strokeWidth: 0.92931,
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_524_14341",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 41,
    width: 23,
    height: 39
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.149776 67.1321C1.31805 61.8749 7.31875 49.2982 11.9653 41.045L20.661 46.5545L12.961 64.4106C18.6917 66.8666 28.4938 65.008 18.736 75.0976C8.13121 86.0632 -1.31057 73.7037 0.149776 67.1321Z",
    fill: "#AE5848"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_524_14341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.149776 67.1321C1.31805 61.8749 7.31875 49.2982 11.9653 41.045L20.661 46.5545L12.961 64.4106C18.6917 66.8666 28.4938 65.008 18.736 75.0976C8.13121 86.0632 -1.31057 73.7037 0.149776 67.1321Z",
    fill: "#AE5848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6825 60.6932C12.4963 56.7769 5.28751 50.3646 4.59717 49.6743L11.2351 40.8458L20.5282 54.8519L15.6825 60.6932Z",
    fill: "#843628"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_524_14341",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 24,
    width: 60,
    height: 27
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6675 50.3433H24.4691V42.1071L20.7273 48.6122L9.37646 42.1071C12.1865 37.8145 20.0419 28.9109 24.4691 27.6364C30.0032 26.0433 43.8273 23.6536 51.5273 24.251C57.6873 24.729 65.7768 35.0709 68.454 40.4476L58.4308 48.6122L54.7135 42.7709L55.6675 50.3433Z",
    fill: "#F2CBB9"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_524_14341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6675 50.3433H24.4691V42.1071L20.7273 48.6122L9.37646 42.1071C12.1865 37.8145 20.0419 28.9109 24.4691 27.6364C30.0032 26.0433 43.8273 23.6536 51.5273 24.251C57.6873 24.729 65.7768 35.0709 68.454 40.4476L58.4308 48.6122L54.7135 42.7709L55.6675 50.3433Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7179 34.2743L56.2403 49.2096",
    stroke: "#DD8401",
    strokeWidth: 0.92931,
    strokeLinejoin: "bevel"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7528 44.9477C33.4866 43.2426 36.2886 42.177 37.2893 41.8218C43.6272 39.3352 42.0261 43.5268 39.3575 44.5214C36.6889 45.516 32.0189 46.6527 32.7528 44.9477Z",
    fill: "#AE5848"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_524_14341",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 30,
    width: 41,
    height: 44
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06622 44.6477C10.7903 42.8628 21.4732 33.2991 23.4623 31.4943C25.4514 29.6895 26.7836 31.0554 28.0131 32.512C29.2425 33.9686 45.0641 51.3865 46.5538 53.0124C48.0435 54.6383 48.4528 56.9277 46.8519 58.6254C45.2511 60.3231 36.2434 70.0481 34.591 71.7432C32.9386 73.4382 31.6579 74.5952 28.9626 71.7773C26.2674 68.9593 13.8199 55.2587 9.84692 51.1346C5.87394 47.0104 7.34215 46.4325 9.06622 44.6477Z",
    fill: "#FF7B7B"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_524_14341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.0661 44.6477C10.7902 42.8628 21.4731 33.2991 23.4622 31.4943C25.4513 29.6895 26.7835 31.0554 28.013 32.512C29.2424 33.9686 45.064 51.3865 46.5537 53.0124C48.0434 54.6383 48.4526 56.9277 46.8518 58.6254C45.251 60.3231 36.2433 70.0481 34.5909 71.7432C32.9384 73.4382 31.6578 74.5952 28.9625 71.7773C26.2672 68.9593 13.8198 55.2587 9.84679 51.1346C5.87381 47.0104 7.34203 46.4325 9.0661 44.6477Z",
    fill: "#A8ACBC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.7369,
    cy: 50.1991,
    rx: 3.5181,
    ry: 2.65517,
    transform: "rotate(-45.9565 27.7369 50.1991)",
    fill: "#FFF8E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2646 62.3218C30.1429 63.427 30.6885 64.5061 31.6507 65.0633C32.0956 65.3313 32.821 65.6422 33.642 65.9118C34.4631 66.1814 35.2316 66.3611 35.7487 66.409C36.854 66.5307 37.933 65.9851 38.4903 65.0229C38.7582 64.5781 39.0692 63.8526 39.3388 63.0316C39.6084 62.2105 39.788 61.442 39.8359 60.9249C39.9576 59.8196 39.4121 58.7406 38.4498 58.1834C38.005 57.9154 37.2796 57.6045 36.4585 57.3348C35.6375 57.0652 34.8689 56.8856 34.3519 56.8377C33.2466 56.716 32.1676 57.2615 31.6103 58.2238C31.3424 58.6686 31.0314 59.394 30.7618 60.2151C30.4922 61.0361 30.3125 61.8047 30.2646 62.3218Z",
    fill: "#01B388",
    stroke: "white",
    strokeWidth: 0.92931
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8027 59.262C34.819 59.4591 34.9299 59.6404 35.1058 59.7408C35.2085 59.8044 35.392 59.8817 35.5997 59.9499C35.8074 60.0181 36.001 60.0646 36.1214 60.0743C36.3225 60.0977 36.5194 60.0175 36.6493 59.8684C36.6965 59.8157 36.7694 59.8012 36.8284 59.8291C36.8438 59.8342 36.8579 59.8431 36.8695 59.8469C37.1594 59.9762 37.384 60.0968 37.5074 60.1885C37.5883 60.2534 37.6247 60.3634 37.5906 60.4673C37.5893 60.4711 37.5893 60.4711 37.588 60.4749C37.5868 60.4788 37.5855 60.4826 37.5842 60.4865L37.583 60.4903C37.5817 60.4942 37.5817 60.4942 37.5805 60.498C37.4538 60.8059 37.0201 61.4775 36.4601 62.2227C35.8185 63.0732 35.2248 63.7392 35.0204 63.8425C34.9885 63.8619 34.9514 63.871 34.9155 63.8763C34.9015 63.8802 34.8836 63.8828 34.8631 63.8803C34.7517 63.8821 34.5556 63.8433 34.344 63.7738C34.1324 63.7043 33.9515 63.6194 33.8628 63.5519C33.8461 63.5379 33.832 63.529 33.823 63.5175C33.7973 63.492 33.7779 63.4601 33.7586 63.4282C33.6539 63.2276 33.5706 62.3393 33.5594 61.2702C33.5501 60.338 33.5991 59.5401 33.6796 59.2171C33.6808 59.2132 33.6808 59.2132 33.6821 59.2094L33.6834 59.2055C33.6846 59.2017 33.6859 59.1978 33.6871 59.194C33.6884 59.1901 33.6884 59.1901 33.6897 59.1863C33.7238 59.0824 33.8182 59.0154 33.9219 59.0111C34.0769 59.0066 34.3254 59.0413 34.6382 59.1142C34.6497 59.118 34.6702 59.1204 34.6856 59.1255C34.7484 59.1419 34.7948 59.1954 34.8027 59.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.073 45.8632L32.9024 74.3786",
    stroke: "#303858",
    strokeWidth: 0.92931,
    strokeLinejoin: "bevel"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18164 68.2604L37.986 43.1026L41.1722 43.1026C43.0287 42.6086 44.4247 43.7001 43.2963 45.7578C44.8149 45.2219 46.2598 45.9134 44.8894 48.0147C43.8937 49.5414 26.3917 66.9328 16.811 76.8897L8.18164 68.2604Z",
    fill: "#AE5848"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9336 50.4595C32.8522 48.9508 33.3861 46.0009 33.5985 44.9605C34.741 38.2488 37.5042 41.784 36.9783 44.583C36.4524 47.3819 35.015 51.9683 33.9336 50.4595Z",
    fill: "#AE5848"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5472 27.5036C30.0869 19.7372 41.4377 17.082 45.4869 25.9768",
    stroke: "#004736",
    strokeWidth: 0.92931,
    strokeLinejoin: "bevel"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6799 24.0519C34.4679 19.87 39.3136 19.9364 42.898 22.3924",
    stroke: "#006B51",
    strokeWidth: 2.92069,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3292 32.3915C46.9518 33.8878 46.4118 36.9685 42.8616 36.5512",
    stroke: "#004736",
    strokeWidth: 0.92931,
    strokeLinejoin: "bevel"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.0708,
    cy: 36.423,
    rx: 1.26121,
    ry: 0.99569,
    transform: "rotate(11.1341 42.0708 36.423)",
    fill: "#006B51"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7035 32.2968C34.0494 33.0864 32.5558 33.2759 31.3038 32.2386C30.0517 31.2014 29.96 29.6987 30.6142 28.909C31.2684 28.1193 32.7619 27.9299 34.014 28.9671C35.266 30.0044 35.3577 31.5071 34.7035 32.2968Z",
    fill: "#004736",
    stroke: "#006B51",
    strokeWidth: 2.12414
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0488 31.7859C44.0512 31.5482 43.221 30.2924 43.5978 28.7107C43.9746 27.1291 45.2819 26.3824 46.2794 26.6201C47.2769 26.8577 48.1072 28.1136 47.7304 29.6952C47.3536 31.2769 46.0463 32.0235 45.0488 31.7859Z",
    fill: "#004736",
    stroke: "#006B51",
    strokeWidth: 2.12414
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9238 44.6958L38.9152 42.3062",
    stroke: "#843628",
    strokeWidth: 0.92931,
    strokeLinejoin: "bevel"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3981 6.64537C27.3466 1.67034 30.5778 1.67044 36.7837 9.928L34.4757 12.3386C32.3763 13.2678 31.0288 13.0145 28.1159 10.2357C31.2445 14.6979 28.1159 14.2874 25.9618 11.6205C28.8852 18.1341 23.7563 16.2877 18.1658 11.2615C24.2692 19.1599 18.73 29.8793 7.95933 20.1345C-2.81137 10.3897 3.65108 4.18352 13.7037 14.6979C1.13788 1.26003 9.90832 -6.023 24.2692 7.61997C20.9355 1.56778 24.8847 1.41391 29.3981 6.64537Z",
    fill: "#2F3030"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_524_14341",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 7,
    width: 14,
    height: 20
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.1428,
    cy: 16.7594,
    rx: 6.26463,
    ry: 9.30746,
    transform: "rotate(-7.28534 37.1428 16.7594)",
    fill: "#C4C4C4"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_524_14341)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.1426,
    cy: 16.7594,
    rx: 6.26463,
    ry: 9.30746,
    transform: "rotate(-7.28534 37.1426 16.7594)",
    fill: "#F2CBB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6052 11.1587C41.4814 13.7522 37.2966 13.7232 34.6296 12.4409C33.6038 16.0825 32.2703 18.1853 29.911 20.1856L27.603 9.46618L35.1938 4.33728L43.6052 11.1587Z",
    fill: "#2F3030"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetNewPasswordSucceed);
export default __webpack_public_path__ + "static/media/set_new_password_succeed.b24093af0c05be812d1513ee2d47878e.svg";
export { ForwardRef as ReactComponent };